import './assets/user_agent_chrome.css';
import './assets/tailwind.css';
import 'element-plus/dist/index.css';

import Bugsnag from '@bugsnag/js';
import {
  ElDialog,
  ElImage,
  ElLoading,
} from 'element-plus';
import { createApp } from 'vue';

import App from './App.vue';
import StreamPip from './components/StreamPip/StreamPip.vue';
import { $, $el } from './js/browser';
import { IS_DEBUG_MODE, IS_DEV_STAGE, IS_PROD_STAGE } from './js/constants';
import vueI18n from './plugins/i18n';
import { globalConfig } from './store/globalConfig';

const app = createApp(App);

app.use(vueI18n);
app.use(ElLoading);
app.use(ElImage);
app.use(ElDialog);
const vuePlugin = Bugsnag.getPlugin('vue'); if (vuePlugin) { app.use(vuePlugin); }

// 為了不影響已在線上的 CMS 頁面，改成向前相容
// globalConfig.value.cmsMountPointId 提供給使用者指定 mount id 名稱
const cmsAppName = globalConfig.value.cmsMountPointId;
let cmsMountPoint = $(`#${cmsAppName}`);
if (!cmsMountPoint) {
  cmsMountPoint = $el('div', { id: cmsAppName });
  document.body.appendChild(cmsMountPoint);
}

cmsMountPoint.classList.add('handsup-cms-scope');
app.mount(cmsMountPoint);

// PIP 功能另外 Mount 一個 app 進行管理
const pip = createApp(StreamPip);
const pipMountPoint = $el('div', { id: 'HANDSUP_PIP' });
pipMountPoint.classList.add('handsup-cms-scope');

document.body.appendChild(pipMountPoint);
pip.mount(pipMountPoint);

// NOTE: 在 local 端使用 prod 環境的提醒樣式
if (IS_DEBUG_MODE && IS_PROD_STAGE) {
  const styleEl = document.createElement('style');
  document.body.appendChild(styleEl);
  styleEl.textContent = `
  body {
    animation-name: danger-effect;
    animation-duration: 3s;
    animation-iteration-count: infinite;
  }
  @keyframes danger-effect {
    0% {
      box-shadow: inset 0px 0px 40px red;
    }
    50% {
      box-shadow: inset 0px 0px 10px red;
    }
    100% {
      box-shadow: inset 0px 0px 40px red;
    }
  }
  `;
}

// NOTE: 僅限在測試環境，提供可測試 PIP 模式
if (IS_DEV_STAGE) {
  const urlObject = new URL(location.href);

  if (urlObject.searchParams.has('piponly')) {
    const appEl = document.querySelector('#app') as HTMLElement | null;
    if (appEl) { appEl.style.height = '100vh'; }

    const h1El = document.createElement('h1');
    h1El.style.fontSize = '100px';
    h1El.appendChild(document.createTextNode('Only PIP test page'));
    if (appEl) { appEl.appendChild(h1El); }
  }
}
